import { qualify } from 'api/targeting'
import store from 'config/store'
import { setMatchedConversationRoutingRules } from 'modules/conversations/actions'
import { evaluateCampaignTargetingConditions, evaluateRoutingTargetingConditions } from 'modules/targeting/evaluation'
import { getTargetingEvaluationContext } from 'modules/targeting/utils'
import { TargetingEvaluationOutcome } from 'types/targeting'
import { isNilOrEmpty,log } from 'utils'

export interface CollectAndQualifyParams {
  campaignId: number,
  formData: Record<string, string>,
  mapFields?: boolean
}

export const collectAndQualify = async ({ formData, mapFields, campaignId }: CollectAndQualifyParams): Promise<boolean> => {
  if (isNilOrEmpty(formData) || !campaignId) {
    return false
  }

  const { embed } = store.getState()
  const { id: embedId } = embed

  const clientSideContext = getTargetingEvaluationContext()

  try {
    const { data } = await qualify({
      embedId,
      mappingId: campaignId,
      campaignIds: [campaignId],
      formData,
      clientSideContext,
      mapFields
    })

    if (!isNilOrEmpty(data.routingEvaluationResults)) {
      const matchedRoutingRules = await evaluateRoutingTargetingConditions(data.routingEvaluationResults)
      store.dispatch(setMatchedConversationRoutingRules(matchedRoutingRules))
    }

    const matched = (
      !isNilOrEmpty(data.campaignTargetingResults) &&
      data.campaignTargetingResults[0].evaluationMatchOutcome === TargetingEvaluationOutcome.MATCH
    )

    if (matched) {
      await evaluateCampaignTargetingConditions({
        conditions: data.campaignTargetingResults
      })
    }

    return matched
  } catch (err) {
    log({ data: [err], type: 'warn' })
  }

  return false
}
